











import VueOptions from '@utils/VueOptions'
import CKEditor from '@ckeditor/ckeditor5-vue2'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

settings =
  name: 'Editor'

  vue:
    props: ['value', 'options']

    components:
      ckeditor: CKEditor.component

    data: ->
      editor: ClassicEditor
      isReady: false

    computed:
      html:
        get: -> if @isReady then @value || '' else ''
        set: (v) -> @$emit 'update:value', v

      config: ->
        defaultConfig =
          toolbar:
            items: [
              'bold', 'italic', '|',
              # 'link', '|',
              'bulletedList', 'numberedList', '|',
              'undo', 'redo'
            ]
        Object.assign defaultConfig, @options

    methods:
      onEditorReady: ->
        @isReady = true

export default VueOptions.vue settings
